/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Role_BuyerInputs */

const en_contact_role_buyer = /** @type {(inputs: Contact_Role_BuyerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buyer`)
};

/**
* | output |
* | --- |
* | "Buyer" |
*
* @param {Contact_Role_BuyerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_role_buyer = /** @type {((inputs?: Contact_Role_BuyerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Role_BuyerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_role_buyer(inputs)
});